import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MetaWrapper = ({ title, description, noIndex = false, children }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title;

    let metaRobots = document.querySelector("meta[name='robots']");
    if (noIndex) {
      if (!metaRobots) {
        metaRobots = document.createElement("meta");
        metaRobots.name = "robots";
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute("content", "noindex, nofollow");
    } else if (metaRobots) {
      metaRobots.remove();
    }

    let metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    } else {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      metaDescription.content = description;
      document.head.appendChild(metaDescription);
    }

    const baseUrl = "https://paperlive.in";
    const canonicalUrl = baseUrl + location.pathname;

    let linkCanonical = document.querySelector("link[rel='canonical']");
    if (linkCanonical) {
      linkCanonical.setAttribute("href", canonicalUrl);
    } else {
      linkCanonical = document.createElement("link");
      linkCanonical.rel = "canonical";
      linkCanonical.href = canonicalUrl;
      document.head.appendChild(linkCanonical);
    }

  }, [title, description, noIndex, location.pathname]);

  return <>{children}</>;
};

export default MetaWrapper;
